import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IGenerateListPayload {
    data: any
    sagaCB?: {
        onSuccess?: any
        onError?: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const generateList = createSlice({
    name: 'hub/matchLists/generate-list',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IGenerateListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.data = { count: 0, data: [] }
            state.errors = action.payload
        }
    }
})

export const generateListActions = generateList.actions
export default generateList.reducer
